import { AccountLoginSecurityWebComponent } from './component/AccountLoginSecurityWebComponent';
import { WEB_COMPONENT_ACCOUNT_LOGIN_SECURITY } from '../../../webcomponents.constants';

export { AccountLoginSecurityWebComponent };

window.customElements.define(WEB_COMPONENT_ACCOUNT_LOGIN_SECURITY, AccountLoginSecurityWebComponent);
